import React from "react";
import i18next from "i18next";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { FiCalendar } from "react-icons/fi";
import { employeesService } from "services";
import * as userActions from "actions/userActions";
import { errorFormating } from "utils/utils";
import Layout from "components/Layout";
import Modal from "components/Modal";
import Avatar from "components/Avatar";
import AvatarEdit from "components/Avatar/AvatarEdit";
import ChangePassword from "components/ChangePassword";
import { showModal, hideModal } from "actions/modalActions";
import SubmitButton from "components/SubmitButton";
import LocaleSelect from "components/Shared/LocaleSelect";
import { isSupervisor } from "utils/utils";

class Profile extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const user = this.props.user;
		const role = user.roles.filter((item) => item !== "SUPERVISOR");
		user.role = role.toString();

		this.state = {
			isLoading: false,
			errors: {},
			user,
			prevUser: user,
		};

		this.closeModal = this.closeModal.bind(this);
		this.openAvatarModal = this.openAvatarModal.bind(this);
		this.openPasswordModal = this.openPasswordModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openAvatarModal() {
		this.props.showModal(
			{
				open: true,
				title: i18next.t("profile.editAvatar"),
				style: { width: "300px" },
				content: (
					<AvatarEdit userId={this.state.user.id} onClose={this.closeModal} />
				),
				closeModal: this.closeModal,
			},
			"empty"
		);
	}

	openPasswordModal() {
		this.props.showModal(
			{
				open: true,
				title: i18next.t("profile.changePassword"),
				style: { width: "320px" },
				content: <ChangePassword handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"empty"
		);
	}

	checkValidField = (name) => {
		return (
			this.state.errors[name] !== undefined && this.state.errors[name] !== ""
		);
	};

	handleChange = (event) => {
		const { user } = this.state;

		this.setState({
			prevUser: user,
			user: {
				...user,
				[event.target.id]: event.target.value,
			},
		});
	};

	_saveEmployee = async () => {
		const { user } = this.state;
		const response = await employeesService.update(user);

		if (response.ok) {
			toastr.success(
				i18next.t("common.success"),
				i18next.t("profile.changesSaved")
			);
		}

		this.setState({
			prevUser: user,
			errors: errorFormating(response),
		});
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		await this._saveEmployee();
		await this.props.update();
	};

	getSupervisedGroups = () =>
		this.props.user.groups_supervised.map((group, i) => {
			return <li key={i}>{group.name}</li>;
		});

	render() {
		const { user } = this.state;

		return (
			<>
				<Layout className="page-profile">
					<div className="heading">
						<h1 className="title">{i18next.t("profile.myProfile")}</h1>
					</div>
					<div className="page-container container">
						<div className="page-content">
							<div className="content-heading">
								<Avatar
									onClick={this.openAvatarModal}
									userId={user.id}
									className="avatar-editable avatar-lg"
									alt={user.name}
								/>

								{isSupervisor() && (
									<div className="form-group no-form form-group-supervised">
										<p className="mb5">
											<strong>{i18next.t("profile.supervises")}</strong>
										</p>
										<ul className="list-supervised">
											{this.getSupervisedGroups()}
										</ul>
									</div>
								)}
							</div>

							<form className="form-profile" onSubmit={this.handleSubmit}>
								<Row>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="name">
											<FormLabel>
												{i18next.t("employee.name")}{" "}
												<span className="label-required">*</span>
											</FormLabel>
											<FormControl
												type="text"
												value={user.name}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												placeholder={i18next.t("employee.namePlaceholder")}
												isInvalid={this.checkValidField("name")}
											/>
											<FormControl.Feedback type="invalid">
												{this.state.errors.name}
											</FormControl.Feedback>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="surname">
											<FormLabel>
												{i18next.t("employee.surname")}{" "}
												<span className="label-required">*</span>
											</FormLabel>
											<FormControl
												type="text"
												value={user.surname}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												placeholder={i18next.t("employee.surnamePlaceholder")}
												isInvalid={this.checkValidField("surname")}
											/>
											<FormControl.Feedback type="invalid">
												{this.state.errors.surname}
											</FormControl.Feedback>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="email">
											<FormLabel>
												{i18next.t("employee.email")}{" "}
												<span className="label-required">*</span>
											</FormLabel>
											<FormControl
												type="email"
												value={user.email}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												placeholder={i18next.t("employee.email")}
												isInvalid={this.checkValidField("email")}
											/>
											<FormControl.Feedback type="invalid">
												{this.state.errors.email}
											</FormControl.Feedback>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="position">
											<FormLabel>{i18next.t("employee.position")}</FormLabel>
											<FormControl
												type="text"
												value={user.position}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												placeholder={i18next.t("employee.positionPlaceholder")}
											/>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup
											controlId="birthday"
											className={`form-group form-date ${user.birthday === "" && "empty"}`}
										>
											<FormLabel>{i18next.t("employee.birthday")}</FormLabel>
											<FormControl
												type="date"
												value={user.birthday}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												isInvalid={this.checkValidField("birthday")}
											/>
											<FiCalendar />
											<FormControl.Feedback type="invalid">
												{this.state.errors.birthday}
											</FormControl.Feedback>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="phone">
											<FormLabel>{i18next.t("employee.phone")}</FormLabel>
											<FormControl
												type="text"
												value={user.phone}
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												placeholder={i18next.t("employee.phonePlaceholder")}
												isInvalid={this.checkValidField("phone")}
											/>
											<FormControl.Feedback type="invalid">
												{this.state.errors.phone}
											</FormControl.Feedback>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup
											controlId="start_day"
											className="form-group form-date"
										>
											<FormLabel>{i18next.t("employee.startDay")}</FormLabel>
											<FormControl
												type="text"
												value={moment(user.start_day).format("DD/MM/YYYY")}
												disabled
											/>
											<FiCalendar />
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="role">
											<FormLabel>{i18next.t("employee.role")}</FormLabel>
											<FormControl value={user.role} disabled as="select">
												<option value="ADMIN">
													{i18next.t("employee.roleAdmin")}
												</option>
												<option value="EMPLOYEE">
													{i18next.t("employee.roleEmployee")}
												</option>
											</FormControl>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="code">
											<FormLabel>{i18next.t("employee.code")}</FormLabel>
											<FormControl
												type="text"
												value={user.code}
												disabled
												//onChange={this.handleChange}
												//onBlur={ this.handleBlur }
												placeholder={i18next.t("employee.codePlaceholder")}
												//isInvalid = {this.checkValidField('code')}
											/>
											<FormControl.Feedback type="invalid">
												{this.state.errors.code}
											</FormControl.Feedback>
										</FormGroup>
									</Col>

									<Col sm={6} md={4} lg={3}>
										<FormGroup
											className="form-group"
											controlId="time_registration_balance_calculation"
										>
											<FormLabel>
												{i18next.t("employee.balanceCalculation")}
											</FormLabel>
											<FormControl
												onChange={this.handleChange}
												// onBlur={this.handleBlur}
												value={user.time_registration_balance_calculation}
												disabled={!user.roles.includes("ADMIN")}
												as="select"
											>
												<option value="PLANNED_HOURS">
													{i18next.t("times.balance.plannedHours")}
												</option>
												<option value="TARGET_HOURS">
													{i18next.t("times.balance.targetHours")}
												</option>
											</FormControl>
										</FormGroup>
									</Col>
									<Col sm={6} md={4} lg={3}>
										<FormGroup className="form-group" controlId="locale">
											<FormLabel>{i18next.t("employee.locale")}</FormLabel>
											<LocaleSelect
												value={user.locale || "es"}
												onChange={(val) =>
													this.setState((prev) => ({
														user: { ...prev.user, locale: val },
													}))
												}
											/>
										</FormGroup>
									</Col>
								</Row>

								<div className="row-buttons">
									<SubmitButton
										type="submit"
										isLoading={this.state.isLoading}
										text={i18next.t("profile.saveData")}
										loadingText={i18next.t("common.saving")}
									/>

									<button
										type="button"
										className="btn btn-outline-primary button-password"
										onClick={this.openPasswordModal}
									>
										{i18next.t("profile.changePassword")}
									</button>
								</div>
							</form>
						</div>
					</div>
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	update: () => dispatch(userActions.update()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
